module.exports = __webpack_public_path__ + "img/logo1.30f6289c.png";